import React, { useEffect, useState } from 'react';
import { Button, Col, Icon, Row } from '../../../../../../components/Component';
import TextInput from '../../../../../components/inputs/TextInput';
import { useDispatch } from 'react-redux';
import { messageToast } from '../../../../../../utils/Utils';
import * as app_consts from "../../../../../../constants/react_app_consts";
import { Alert, Spinner } from 'reactstrap';
import { fail_complete_processing_delivery_note, loading_complete_processing_delivery_note, reset_complete_processing_delivery_note, success_complete_processing_delivery_note } from '../../../../../../reducers/dashboard_reducers/delivery_notes/complete_processing_delivery_note_Slice';
import { COMPLETE_PROCESSING_DELIVERY_NOTE_ACCESS_DENIED_MSG, COMPLETE_PROCESSING_DELIVERY_NOTE_ERR_MSG, COMPLETE_PROCESSING_DELIVERY_NOTE_SUCCESS_MSG } from '../../../../../../constants/success_error_messages_consts';
import { FINALIZE_DN_PROCESSING_API } from '../../../../../../api/api_data';
import { useSelector } from 'react-redux';
import { employee_dashboard_actions_helper } from '../../../../../../actions/actions_helper';
import { isWeighbridgeWeightSequenceValid, resolveWeighbridgeNetWeight } from '../../../../../../utils/weighbridgeUtils';

const initialState = { first_weight: "", second_weight: "", net_weight: "", total_mt_capcity: "", total_density_mt_capacity: "" };

const FinalizeDN = ({ page_data, openModal, successFunction }) => {

  const [sent_data, setSentData] = useState(page_data);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState(initialState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (openModal && page_data)
    {
      const totalCapacitySum = page_data?.product_list?.reduce((sum, item) => {
        // Convert total_capacity_in_mt to a number and add to the sum
        return sum + parseFloat(item?.total_capacity_in_mt);
      }, 0);

      const totalDensityCapacitySum = page_data?.product_list?.reduce((sum, item) => {
        // Convert total_capacity_in_mt to a number and add to the sum
        return sum + parseFloat(item?.uom_details?.total_density_kilos);
      }, 0);

      const firstWeight = page_data?.weigh_bridge_ticket?.first_weight || "";
      const secondWeight = page_data?.weigh_bridge_ticket?.second_weight || "";

      setFormData({
        ...formData,
        total_mt_capcity: totalCapacitySum,
        first_weight: firstWeight,
        second_weight: secondWeight,
        net_weight: resolveWeighbridgeNetWeight(
          page_data?.weigh_bridge_ticket?.net_weight || "",
          firstWeight,
          secondWeight,
        ),
        total_density_mt_capacity: totalDensityCapacitySum,
      });
    }
    setSentData(page_data);

  }, [openModal, page_data]);

  // Handle Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleOnblur = (e) => {
    if (e.target.name === "second_weight")
    {
      if (e.target.value)
      {
        if (!isWeighbridgeWeightSequenceValid(formData.first_weight, e.target.value))
        {
          setFormData({ ...formData, [e.target.name]: "", ["net_weight"]: "" });
          messageToast("Gross Weight Cannot be less than Tare Weight", app_consts.FAIL);
        }
        else
        {
          setFormData({
            ...formData,
            [e.target.name]: parseFloat(e.target.value).toFixed(2),
            ["net_weight"]: resolveWeighbridgeNetWeight(
              formData?.net_weight,
              formData?.first_weight,
              e.target.value,
            ),
          });
        }
      }
      else
      {
        setFormData({ ...formData, [e.target.name]: "", ["net_weight"]: "" });
      }
    }
    else
    {
      if (e.target.value)
      {
        setFormData({ ...formData, [e.target.name]: parseFloat(e.target.value).toFixed(2) });
      }
    }
  };

  const handleSubmit = () => {
    setError("");
    const sent_data = { ...formData, delivery_note_ref_number: page_data?.delivery_note?.delivery_note_ref_number };
    dispatch(
      employee_dashboard_actions_helper(
        loading_complete_processing_delivery_note,
        success_complete_processing_delivery_note,
        fail_complete_processing_delivery_note,
        COMPLETE_PROCESSING_DELIVERY_NOTE_ERR_MSG,
        COMPLETE_PROCESSING_DELIVERY_NOTE_SUCCESS_MSG,
        app_consts.POST,
        FINALIZE_DN_PROCESSING_API,
        sent_data,
        COMPLETE_PROCESSING_DELIVERY_NOTE_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Submit State
  const complete_processing_delivery_note = useSelector((state) => state.complete_processing_delivery_note.complete_processing_delivery_note);

  useEffect(() => {
    if (complete_processing_delivery_note.status !== app_consts.IDLE)
    {
      if (complete_processing_delivery_note.status === app_consts.LOADING)
      {
        setError("");
        setLoading(true);
      } else
      {
        setLoading(false);
        if (complete_processing_delivery_note.status === app_consts.FAIL)
        {
          setError(complete_processing_delivery_note.message);
          messageToast(complete_processing_delivery_note.message, app_consts.FAIL);
        } else if (complete_processing_delivery_note.status === app_consts.SUCCESS)
        {
          successFunction();
          messageToast(COMPLETE_PROCESSING_DELIVERY_NOTE_SUCCESS_MSG, app_consts.SUCCESS);
        }
        dispatch(reset_complete_processing_delivery_note());
      }
    }
  }, [complete_processing_delivery_note]);

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Row className="g-4">
          <div className="form-label-group">
            <label className="form-label text-soft fs-22px">Finalize DN</label>
          </div>
          <TextInput
            parentClassName="mt-4"
            colSize={6}
            label="Tare Weight (MT)"
            type="number"
            id_val="first_weight"
            value={formData.first_weight}
            handleChange={handleChange}
            name="first_weight"
            onBlur={handleOnblur}
          />
          <TextInput
            parentClassName="mt-4"
            colSize={6}
            label="Gross Weight (MT)"
            type="number"
            id_val="second_weight"
            value={formData?.second_weight}
            handleChange={handleChange}
            name="second_weight"
            onBlur={handleOnblur}
            disabled={!formData.first_weight}
          />
          <TextInput
            parentClassName="mt-4"
            colSize={6}
            label="Net Weight (MT)"
            type="number"
            id_val="net_weight"
            disabled
            value={formData?.net_weight}
            handleChange={handleChange}
            name="net_weight"
            onBlur={handleOnblur}
          />
          <TextInput
            parentClassName="mt-4"
            colSize={6}
            label="Total Products Weight (MT)"
            type="number"
            id_val="total_mt_capacity"
            value={formData.total_density_mt_capacity ? parseFloat(formData.total_density_mt_capacity)?.toFixed(2) : ""}
            name="total_mt_capacity"
            disabled
          />
          <TextInput
            parentClassName="mt-4"
            colSize={6}
            label="Total Products Base Weight (MT)"
            type="number"
            id_val="total_mt_capacity"
            value={formData.total_mt_capcity ? parseFloat(formData.total_mt_capcity)?.toFixed(2) : ""}
            name="total_mt_capacity"
            disabled
          />
          {error && (
            <div className="mt-4">
              <Alert color="danger" className="alert-icon">
                {" "}
                <Icon name="alert-circle" />
                {error}{" "}
              </Alert>
            </div>
          )}
          <Col xl="12">
            <div className="form-group">
              <div className="form-control-wrap-flex-wrap justify-end items">
                <Button
                  onClick={handleSubmit}
                  disabled={
                    loading
                      ? loading
                      : !(formData?.first_weight && formData.second_weight)
                  }
                  color="primary"
                  size="md"
                >
                  {loading ? <Spinner size="sm" color="light" /> : "Finalize DN"}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default FinalizeDN;
